import { Group, Stack, Text } from '@mantine/core';
import { Variable } from 'components/Variable';
import dayjs from 'dayjs';
import { i18nKeys, useTranslation } from 'locales';
import type { AutomationLog } from 'modules/Settings/Automation/api';
import { capitalize, isNullish } from 'remeda';
import { type AutomationModel, useGetFieldDefinition } from '../../../../AutomationWizard';
import { ResourceAnchor } from './ResourceAnchor';

type CopyFieldToFieldItemProps = {
  log: Extract<AutomationLog, { newValue: string | null }>;
};

export const CopyFieldToFieldItem = ({ log }: CopyFieldToFieldItemProps) => {
  const { t } = useTranslation();

  const field = useGetFieldDefinition(log.field, log.model);

  if (isNullish(field)) return null;

  const modelTypeToKey: Record<AutomationModel, string> = {
    invoice: t(i18nKeys.AUTOMATION.HISTORY_PANEL.COPY_FIELD_TO_FIELD.OF_INVOICE),
    debtor: t(i18nKeys.AUTOMATION.HISTORY_PANEL.COPY_FIELD_TO_FIELD.OF_CUSTOMER),
  };

  return (
    <Stack gap={2}>
      <Group gap={4}>
        <Text>{t(i18nKeys.AUTOMATION.HISTORY_PANEL.COPY_FIELD_TO_FIELD.VALUE_COPIED)}</Text>
        <Variable color="coral">{log.newValue ?? 'null'}</Variable>
        <Text>{t(i18nKeys.AUTOMATION.HISTORY_PANEL.COPY_FIELD_TO_FIELD.WAS_COPIED)}</Text>
        <Variable color="blue">{field.label}</Variable>
        <Text>{modelTypeToKey[log.model]}</Text>
        <ResourceAnchor log={log} />
      </Group>
      <Text size="sm">{capitalize(dayjs().to(log.date))}</Text>
    </Stack>
  );
};
